<div class="a-richtext" [innerHTML]="text">
</div>
